
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/super/[portfolio]",
      function () {
        return require("private-next-pages/super/[portfolio].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/super/[portfolio]"])
      });
    }
  